import { WalletCategory } from "./enums";
import { WalletCategoryText } from "./consts";

export const WalletHelper = {
  getCategoryText(category: WalletCategory) {
    const mod = category % 10;

    if (mod === 0) return "收款";
    if (mod === 1) return "歸集";
    if (mod === 2) return "雜支";

    return WalletCategoryText[category];
  },
};
